<template>
  <div class="page-header-index-wide">
    <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="年级名称">
              <j-dict-select-tag
                placeholder="请选择年级"
                v-model="queryParam.gradeId"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                style="width: 250px"
                allowClear
              ></j-dict-select-tag>
              <!-- dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order" -->
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="班级名称">
              <j-dict-select-tag
                placeholder="请选择班级"
                v-model="queryParam.classId"
                :dictCode="
                  'school_class,name,id,delete_flag=0 and grade_id=' +
                  (!queryParam.gradeId ? -1 : queryParam.gradeId)
                "
                :async="true"
                style="width: 250px"
              ></j-dict-select-tag>
               <!-- :dictCode="
                  'school_class,name,id,delete_flag=0 and grade_id=' +
                  (!queryParam.gradeId ? -1 : queryParam.gradeId)
                " -->
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="学生姓名">
              <a-input placeholder="请输入学生姓名" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="时间范围">
              <a-range-picker :value="rangeDate" @change="onRangeChange" style="width: 250px" />
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="loadData" icon="search">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-card>

    <a-row :gutter="24">
      <a-col :span="6" :style="{ marginBottom: '24px' }">
        <a-card :loading="loading" style="height: 110px">
          <a-row>
            <a-col :span="12">
              <a-statistic title="家长访问次数" :value="total.parentVisitCnt" />
            </a-col>
            <a-col :span="12">
              <a-statistic title="家长平均访问次数" :precision="2" :value="total.parentVisitAvg" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="6" :style="{ marginBottom: '24px' }">
        <a-card :loading="loading" style="height: 110px">
          <a-row>
            <a-col :span="12">
              <a-statistic title="学生活跃次数" :value="total.studentActivityCnt" />
            </a-col>
            <a-col :span="12">
              <a-statistic
                title="学生平均活跃次数"
                :precision="2"
                :value="total.studentActivityAvg"
              />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="6" :style="{ marginBottom: '24px' }">
        <a-card :loading="loading" style="height: 110px">
          <a-row>
            <a-col :span="12">
              <a-statistic title="提醒次数" :value="total.warnCnt" />
            </a-col>
            <a-col :span="12">
              <a-statistic title="辅导次数" :value="total.tutorCnt" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <!--      <a-col :span="6" :style="{ marginBottom: '24px' }">-->
      <!--        <a-card :loading="loading" style="height:110px">-->
      <!--          <a-row>-->
      <!--            <a-col :span="12">-->
      <!--              <a-statistic title="xx" :value="total.warnCnt"/>-->
      <!--            </a-col>-->
      <!--            <a-col :span="12">-->
      <!--              <a-statistic title="xx" :value="total.tutorCnt" />-->
      <!--            </a-col>-->
      <!--          </a-row>-->
      <!--        </a-card>-->
      <!--      </a-col>-->
    </a-row>

    <split-pane :min-percent="20" :default-percent="70" split="vertical">
      <template slot="paneL">
        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <div class="salesCard">
            <smooth-line-chart-multid
              title="校园情绪趋势"
              :height="250"
              :fields="['愉悦指数', '提醒次数']"
              :dataSource="schoolMood"
            ></smooth-line-chart-multid>
          </div>
        </a-card>

        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <div class="salesCard">
            <a-row>
              <a-col :span="12">
                <smooth-line-chart-multid
                  title="学生活跃情况"
                  :height="250"
                  :fields="['activity']"
                  :dataSource="studentActivity"
                ></smooth-line-chart-multid>
              </a-col>
              <a-col :span="12">
                <smooth-line-chart-multid
                  title="家长访问情况"
                  :height="250"
                  :fields="['visit']"
                  :dataSource="parentVisit"
                ></smooth-line-chart-multid>
              </a-col>
            </a-row>
          </div>
        </a-card>

        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <div class="salesCard">
            <a-row>
              <a-col :span="12">
                <smooth-line-chart-multid
                  title="性别"
                  :height="250"
                  :fields="['男', '女']"
                  :dataSource="sexData"
                ></smooth-line-chart-multid>
              </a-col>
              <a-col :span="12">
                <smooth-line-chart-multid
                  title="年龄"
                  :height="250"
                  :fields="['10~12', '12~14', '14~16']"
                  :dataSource="ageData"
                ></smooth-line-chart-multid>
              </a-col>
            </a-row>
          </div>
        </a-card>

        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <div class="salesCard">
            <smooth-line-chart-multid
              title="成绩"
              :height="250"
              :fields="['语文', '数学', '英语', '物理', '化学']"
              :dataSource="scoreData"
            ></smooth-line-chart-multid>
          </div>
        </a-card>

        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <div class="salesCard">
            <smooth-line-chart-multid
              title="其他成绩"
              :height="250"
              :fields="['体育', '美术']"
              :dataSource="otherScoreData"
            ></smooth-line-chart-multid>
          </div>
        </a-card>
      </template>
      <template slot="paneR">
        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <rank-list title="年级情绪趋势排名" :list="gradeTrendsRanking" />
        </a-card>
        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <rank-list title="班级情绪趋势排名" :list="classTrendsRanking" />
        </a-card>
        <a-card :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
          <rank-list
            title="重点关爱名单"
            :subTitle="['名字', '提醒数', '愉悦指数']"
            :list="careTrendsRanking"
            :careAverage="careAverage"
          />
        </a-card>
      </template>
    </split-pane>
  </div>
</template>

<script>
import RankList from '@/components/chart/RankList'
import BarAndLine from '@/components/chart/BarAndLine'
import { getAction } from '@api/manage'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import splitPane from 'vue-splitpane'
import moment from 'moment'

export default {
  name: 'SchoolMoodTrend',
  components: {
    RankList,
    BarAndLine,
    SmoothLineChartMultid,
    JSearchSelectTag,
    splitPane,
  },
  data() {
    return {
      loading: false,
      queryParam: {},
      //查询数据范围
      rangeDate: [],
      total: {
        parentVisitCnt: 0,
        parentVisitAvg: 0,
        studentActivityCnt: 0,
        studentActivityAvg: 0,
        warnCnt: 0,
        tutorCnt: 0,
      },
      schoolMood: [],
      gradeTrendsRanking: [],
      classTrendsRanking: [],
      careTrendsRanking: [],
      careAverage: {},
      studentActivity: [],
      parentVisit: [],
      scoreData: [
        {
          type: '2024-01-09',
          语文: 86,
          数学: 89,
          英语: 89,
          物理: 95,
          化学: 87,
        },
        {
          type: '2024-01-10',
          语文: 82,
          数学: 88,
          英语: 94,
          物理: 88,
          化学: 95,
        },
        {
          type: '2024-01-11',
          语文: 92,
          数学: 92,
          英语: 90,
          物理: 88,
          化学: 89,
        },
        {
          type: '2024-01-12',
          语文: 89,
          数学: 90,
          英语: 92,
          物理: 90,
          化学: 87,
        },
      ],
      otherScoreData: [
        {
          type: '2024-01-01',
          体育: 95,
          美术: 90,
        },
        {
          type: '2024-01-02',
          体育: 93,
          美术: 93,
        },
        {
          type: '2024-01-03',
          体育: 95,
          美术: 97,
        },
        {
          type: '2024-01-04',
          体育: 98,
          美术: 93,
        },
        {
          type: '2024-01-05',
          体育: 95,
          美术: 94,
        },
      ],
      sexData: [
        {
          type: '2024-01-01',
          男: 22,
          女: 32,
        },
        {
          type: '2024-01-02',
          男: 33,
          女: 27,
        },
        {
          type: '2024-01-03',
          男: 34,
          女: 33,
        },
        {
          type: '2024-01-04',
          男: 25,
          女: 30,
        },
        {
          type: '2024-01-05',
          男: 29,
          女: 30,
        },
      ],
      ageData: [
        {
          type: '2024-01-01',
          '10~12': 33,
          '12~14': 30,
          '14~16': 31,
        },
        {
          type: '2024-01-02',
          '10~12': 28,
          '12~14': 26,
          '14~16': 29,
        },
        {
          type: '2024-01-03',
          '10~12': 29,
          '12~14': 27,
          '14~16': 28,
        },
        {
          type: '2024-01-04',
          '10~12': 27,
          '12~14': 22,
          '14~16': 29,
        },
        {
          type: '2024-01-05',
          '10~12': 30,
          '12~14': 32,
          '14~16': 28,
        },
      ],
    }
  },
  created() {
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.loadData()
  },
  methods: {
    loadData() {
      //获取顶部统计数据
      getAction('/statistic/gradeTrendsRanking', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.gradeTrendsRanking = res.result
        }
      })
      getAction('/statistic/classTrendsRanking', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.classTrendsRanking = res.result
          // this.total = res.result.grade_name
          // this.chartData.studentFaceList = res.result.moodScore;
          // this.chartData.smsPushList = res.result.smsPushList;
          // this.chartData.studentList = res.result.studentList;
          // this.chartData.emoteList = res.result.emoteList;
          // this.chartData.todayStudentFaceCount = res.result.studentFaceList[6].y
          // this.chartData.todaySmsPushCount = res.result.smsPushList[6].y
          // this.chartData.todayStudentCount = res.result.studentList[6].y
          // this.chartData.todayemoteCount = res.result.emoteList[7].y
        }
      })
      getAction('/statistic/careTrendsRanking', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.careTrendsRanking = res.result.ranking
          this.careAverage = res.result.average
          // this.total = res.result.grade_name
          // this.chartData.studentFaceList = res.result.moodScore;
          // this.chartData.smsPushList = res.result.smsPushList;
          // this.chartData.studentList = res.result.studentList;
          // this.chartData.emoteList = res.result.emoteList;
          // this.chartData.todayStudentFaceCount = res.result.studentFaceList[6].y
          // this.chartData.todaySmsPushCount = res.result.smsPushList[6].y
          // this.chartData.todayStudentCount = res.result.studentList[6].y
          // this.chartData.todayemoteCount = res.result.emoteList[7].y
        }
      })
      //提醒次数、情绪趋势
      getAction('/statistic/moodScoreAndWarnNumTrendTheOld', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.schoolMood = res.result
        }
      })
      //家长访问次数/平均访问次数
      getAction('/statistic/parentVisit', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.total.parentVisitCnt = res.result.parentVisitCnt
          this.total.parentVisitAvg = res.result.parentVisitAvg
        }
      })
      //学生活跃次数/平均活跃次数
      getAction('/statistic/studentActivity', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.total.studentActivityCnt = res.result.studentActivityCnt
          this.total.studentActivityAvg = res.result.studentActivityAvg
        }
      })
      //提醒次数
      getAction('/statistic/warnNum', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.total.warnCnt = res.result
        }
      })
      //辅导次数
      getAction('/statistic/counsellingNum', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.total.tutorCnt = res.result
        }
      })
      //学生活跃情况
      getAction('/statistic/studentActivityTrend', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.studentActivity = res.result
        }
      })
      //家长访问情况
      getAction('/statistic/parentVisitTrend', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.parentVisit = res.result
        }
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeType = 'range'
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]

      this.loadData()
    },
  },
}
</script>

<style lang="less" scoped>
.circle-cust {
  position: relative;
  top: 28px;
  left: -100%;
}
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;
  text-align: right;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

/* 首页访问量统计 */
.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 0.95rem;
    line-height: 42px;
    margin-bottom: 4px;
  }
  p {
    line-height: 42px;
    margin: 0;
    a {
      font-weight: 600;
      font-size: 1rem;
    }
  }
}
</style>
